import { gql } from "@apollo/client";

export const GET_DISTRIBUTION_URL = gql`
  query GET_DISTRIBUTION_URL($docId: ObjectId!, $shiftId: ObjectId) {
    getDistributionUrl(docId: $docId, shiftId: $shiftId) {
      distributionUrl
    }
  }
`;
